// extracted by mini-css-extract-plugin
module.exports = {"icon":"typeIcon__icon___2UWO4","required":"typeIcon__required___gOjHX"};